import React from "react";
//import PropTypes from 'prop-types';

import Field from "containers/Field";
import { FormLayout } from "playground/cms/Form";

export function SyncTasksForm(props) {
    const {} = props;
    return (
        <FormLayout.Fieldset pad>
            <Field
                id={"integration"}
                label={"Integracja"}
                fieldType={"select"}
                source={"api:cms.integrations"}
            />
            <Field
                id={"resource_type"}
                fieldType={"select"}
                source={"schema:entries.types"}
                label={"Typ wpisu"}
            />
            <Field
                id={"background_task"}
                fieldType={"checkbox"}
                label={"Uruchamianie w tle"}
            />
            <Field id={"active"} fieldType={"checkbox"} label={"Aktywne"} />
        </FormLayout.Fieldset>
    );
}

SyncTasksForm.propTypes = {};

SyncTasksForm.defaultProps = {};

export default SyncTasksForm;
